'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# ScalesSVG
An SVG graduation cap icon
 */
var ScalesSVG = function ScalesSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 558 473',
      'aria-label': 'Scales',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Scales'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'An SVG scales icon'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        {
          fill: color,
          fillRule: 'nonzero'
        },
        _react2.default.createElement('path', {
          d: 'M100.9,94.9 C102,96.8 102.8,98.3 103.8,99.8 C124.2,132.2 144.6,164.5 165,196.9 C169.8,204.5 168.6,211.3 162.1,215 C156.5,218.1 150.2,216 146.1,209.5 C129.5,183.2 112.9,156.9 96.3,130.5 C94.3,127.3 92.2,124.1 89.9,120.4 C85.9,126.6 82.2,132.5 78.5,138.3 C63.4,162.2 48.4,186.2 33.2,210.1 C28.3,217.8 19.5,218.5 14,211.9 C10.8,207.9 10.8,203.2 14.3,197.6 C27.8,176.2 41.3,154.8 54.7,133.4 C62.7,120.7 70.6,108.1 78.9,95 C77.6,94.6 76.6,94.2 75.6,93.9 C65.6,91.8 60.2,84.6 61,74.5 C61.7,65.9 68.8,59.4 78.5,59.3 C100.7,59.1 122.8,59.2 145,59.2 C164.5,59.2 184,59.1 203.5,59.3 C206.4,59.3 208.3,58.6 210.2,56.2 C216.8,47.9 225,41.4 235.3,37.9 C237.8,37 238.8,35.8 239.3,33 C241.9,17.2 256.5,-1 281.8,0.3 C298.9,1.2 314.8,14.9 318.3,33.2 C318.6,35 320.6,37.1 322.4,37.8 C332.3,41.6 340.5,47.8 347,56 C349,58.5 351.1,59.3 354.1,59.3 C394.3,59.2 434.4,59.2 474.6,59.3 C477.7,59.3 481,59.3 484,60.1 C491.9,62.2 496.7,69.4 496.4,77.8 C496.1,85.6 490.4,92.1 482.4,93.7 C481.3,93.9 480.2,94.3 478.5,94.7 C479.6,96.6 480.6,98.3 481.6,99.9 C502,132.3 522.4,164.7 542.8,197 C545.8,201.7 547.3,206.4 543.8,211.4 C538.7,218.6 529.2,218 524.3,210.3 C510.2,188.1 496.3,165.8 482.2,143.6 C477.4,136 472.6,128.4 467.6,120.4 C460.7,131.3 454,141.8 447.4,152.4 C435.2,171.7 423.1,191 411,210.3 C407.8,215.3 403.2,217.5 398.4,216.2 C393.4,214.9 389.8,211.6 389.7,206.5 C389.7,203.1 391.2,199.4 393.1,196.4 C413.3,164.1 433.6,131.9 453.9,99.6 C454.8,98.2 455.6,96.8 456.7,94.9 C404.8,94.9 353.5,94.9 301.7,94.9 C301.7,207.3 301.7,319.8 301.7,433 C308.7,433 315.5,432.9 322.2,433 C329.5,433.1 336.9,433.1 344.2,433.6 C362.7,435 379.6,454.7 377.8,472.7 C311.8,472.7 245.7,472.7 179.1,472.7 C179.2,459.9 184.4,449.8 194,441.9 C202.2,435.1 212,432.9 222.4,433 C233.4,433.1 244.4,433 255.7,433 C255.7,320.2 255.7,207.8 255.7,94.9 C204.4,94.9 152.9,94.9 100.9,94.9 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M467.8,228.6 C494.6,228.6 521.4,228.6 548.2,228.6 C555.6,228.6 557.4,230.2 557.2,237.7 C555.9,277.4 528.2,311.9 489.4,321.5 C437.7,334.4 387.1,300.4 378.9,247.3 C378.3,243.7 378.1,240 378,236.4 C377.9,230.6 379.8,228.6 385.7,228.6 C407,228.6 428.3,228.6 449.6,228.6 C455.8,228.6 461.8,228.6 467.8,228.6 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M89.8,228.6 C116.8,228.6 143.8,228.6 170.7,228.6 C177.7,228.6 179.3,230.3 179.3,237.1 C178.9,282 141.8,320.5 97,323.9 C50.5,327.4 9.7,295.2 1.5,250.4 C0.7,246 0.3,241.5 0.1,237 C-0.1,230.7 2,228.6 8.3,228.6 C35.6,228.6 62.7,228.6 89.8,228.6 Z'
        })
      )
    )
  );
};

ScalesSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** a color for the icon */
  color: _propTypes2.default.string
};

ScalesSVG.displayName = 'ScalesSVG';

exports.default = ScalesSVG;
ScalesSVG.__docgenInfo = {
  'description': '# ScalesSVG\r\nAn SVG graduation cap icon',
  'methods': [],
  'displayName': 'ScalesSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    }
  }
};